// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { EntityAttachmentsSection } from '@/components/entity-attachments-section';
import { addReturnOrderURLLink } from '@/return-order/api/add-return-order-url-link';
import { deleteReturnOrderFile } from '@/return-order/api/delete-return-order-file';
import { uploadReturnOrderFile } from '@/return-order/api/upload-return-order-file';
import { useReturnOrderFiles } from '@/return-order/hooks/use-return-order-files';
import { useReturnOrderURLLinks } from '@/return-order/hooks/use-return-order-url-links';
import {
  returnOrderDetailQueryKey,
  returnOrderFilesQueryKey,
  returnOrderURLLinksQueryKey,
} from '@/return-order/query-keys';

interface Props {
  /** The key of the return order */
  returnOrderKey: string;
  /** The ID of the return order (used for uploads) */
  returnOrderId: string;
}

/**
 * Section component for displaying and managing files and URL links on the
 * return order detail page. Rendered inline in the right column.
 */
export function ReturnOrderAttachmentsSection(props: Props) {
  const filesData = useReturnOrderFiles({
    returnOrderKey: props.returnOrderKey,
  });
  const urlLinksData = useReturnOrderURLLinks({
    returnOrderKey: props.returnOrderKey,
  });

  return (
    <EntityAttachmentsSection
      entityKey={props.returnOrderKey}
      entityId={props.returnOrderId}
      ownerType="returnOrder"
      filesData={filesData}
      urlLinksData={urlLinksData}
      uploadFile={uploadReturnOrderFile}
      addURLLink={addReturnOrderURLLink}
      deleteFile={deleteReturnOrderFile}
      queryKeysToInvalidate={[
        returnOrderDetailQueryKey(props.returnOrderKey),
        returnOrderFilesQueryKey(props.returnOrderKey),
        returnOrderURLLinksQueryKey(props.returnOrderKey),
      ]}
    />
  );
}
